import {useCallback, useEffect, useState} from 'react'
import {useMsal} from '@azure/msal-react'
import {loginRequest} from '@/helpers/Auth/authService'
import {InteractionStatus} from '@azure/msal-browser'
import { ROUTES } from '@/utils/constants/routesConstants'

export const useAuth = () => {
  const {instance, accounts, inProgress} = useMsal()
  const [accessToken, setAaccessToken] = useState()

  const fetchToken = useCallback(async () => {
    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      setAaccessToken(response.accessToken)
      localStorage.setItem('msalAccessToken', response.idToken) //here idToken is used to authenticate APIs
    } catch (error) {
      if (['interaction_required', 'invalid_grant', 'no_tokens_found'].includes(error.errorCode)) {
        // Token is expired or interaction is required, prompt user to login again
        instance.loginRedirect(loginRequest)
      } else {
        console.error('Error fetching token:', error)
      }
    }
  }, [accounts, instance])

  const signInWithRedirect = () => {
    instance.loginRedirect(loginRequest)
  }

  const signOut = () => {
    localStorage.removeItem('msalAccessToken')
    instance.logoutRedirect({
      postLogoutRedirectUri: ROUTES.HOME,
    })
  }

  const handleLogin = (loginType) => {
    if (inProgress === InteractionStatus.None) {
      if (loginType === 'popup') {
        instance.loginPopup(loginRequest)
      } else {
        instance.loginRedirect(loginRequest).catch(e => {
          console.log(e)
        })
      }
    }
  }

  useEffect(() => {
    if (accounts.length > 0) fetchToken()
  }, [accounts, fetchToken])

  return {
    authState: inProgress,
    instance,
    accessToken,
    handleLogin,
    signInWithRedirect,
    signOut,
    account: accounts[0],
    isAuthenticated: accounts.length > 0,
    claims: (accounts[0]?.idTokenClaims || {}),
  }
}
